export var DsgRequestType;
(function (DsgRequestType) {
    DsgRequestType["DSG_REQUEST_TYPE_PUT"] = "PUT";
    DsgRequestType["DSG_REQUEST_TYPE_GET"] = "GET";
})(DsgRequestType || (DsgRequestType = {}));
